<ng-container>
  <section class="list-wrapper">
    <!--      <div class="filter-list row">-->
    <!--        <app-filter-button class="col-auto ml-auto" [filterNavigationConfig]="filterNavigationConfig"></app-filter-button>-->
    <!--      </div>-->

    <div class="tabs">
      <app-tab [theme]="'trapezoid'" [tabs]="tabs" [selectedIndex]="selectedIndex" (currentIndex)="onTabIndexChange($event)">
        <div class="flex align-center justify-space-between bg-white flex-wrap">
          <app-list-filter-controls
            (searchValue)="setFilterParams({ searchTerm: $event, offset: 0 }, null, true)"
            (sortBy)="onSortChange($event)"
            [includeFilterButton]="false"
          ></app-list-filter-controls>
          <div class="flex align-center">
            <app-export-button class="mr-2" (buttonClicked)="onExportClicked()"></app-export-button>

            <app-filter-button [filterNavigationConfig]="filterNavigationConfig" [isPrimaryLightColor]="true"></app-filter-button>
          </div>
        </div>
        <app-entity-listing
          [totalCount]="totalRowsCount"
          [emptyStateMainLabel]="'TransportationPayments.EmptyStateMainLabel' | translate"
          [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
          [pageIndex]="(filters.params.offset + 1)"
          [pageSize]="filters.params.limit"
          (pageIndexChanged)="setFilterParams({ offset: $event - 1}, null, true)"
          [state]="sectionState"
        >
          <div class="table scrollable scrollable--x">
            <table mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.InvoiceId" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef class="title-width">{{ "TransportationPayments.CreatedBy" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ (element.createdBy?.firstName && element.createdBy?.lastName) ? element.createdBy?.firstName + ' ' + element.createdBy?.lastName
                  : '_______' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.CreatedAt" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ (element.createdAt | date: 'dd LLL YYYY') || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="paymentDate">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.PaymentDate" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ (element.paidAt | date: 'dd LLL YYYY') || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="from">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.From" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ (element.startDate | date: 'dd LLL YYYY') || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="to">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.To" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ (element.endDate | date: 'dd LLL YYYY') || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.Total" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.amount?.toLocaleString() || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="paymentStatus">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.PaymentStatus" | translate }}</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="{'status-paid': element.status === Status.PAID , 'status-pending':  element.status === Status.PENDING ,'status-rejected':  element.status === Status.REJECTED }"
                >
                  <app-rect-tag [color]="colorPerStatus[element?.status]">
                    <span class="text-nowrap">{{ 'Enum.TransportationPaymentsStatus.' + element.status | translate }}</span>
                  </app-rect-tag>
                </td>
              </ng-container>

              <ng-container matColumnDef="bankRef">
                <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.BankRef" | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.bankReference || '_______' }}</td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th class="center action-width" mat-header-cell *matHeaderCellDef></th>

                <td
                  app-click-stop-propagation
                  [matMenuTriggerFor]="menu"
                  class="center action column-sticky"
                  app-click-stop-propagation
                  mat-cell
                  *matCellDef="let element"
                >
                  <div class="flex justify-center align-center">
                    <div class="flex justify-center">
                      <app-icon name="menu-vert" class="cursor-pointer text-700"></app-icon>
                    </div>

                    <mat-menu class="item-actions" #menu>
                      <mat-option (click)="navigateToDetailsPage(element.id)">
                        <span>{{ "Buttons.Details" | translate }}</span>
                      </mat-option>

                      <mat-option *ngIf="element.status === Status.PENDING" (click)="onPreviewMarkModal(element, 'paid')">
                        <span>{{ "Buttons.MarkAsPaid" | translate }}</span>
                      </mat-option>

                      <mat-option *ngIf="element.status === Status.PENDING" (click)="onPreviewMarkModal(element, 'rejected')">
                        <span>{{ "Buttons.MarkAsReject" | translate }}</span>
                      </mat-option>
                    </mat-menu>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="navigateToDetailsPage(row.id)"></tr>
            </table>
          </div>
        </app-entity-listing>
      </app-tab>
    </div>
  </section>
</ng-container>

<!-- Mark As Paid modal -->
<app-modal
  #previewMarkModal
  title="{{ actionType ==='paid' ? ('TransportationPayments.MarkAsPaid' | translate) : ('TransportationPayments.MarkAsRejected' | translate) }} ({{'TransportationPayments.InvoiceId' | translate }}: {{selectedElement.id}}) "
  [maxWidth]="800"
  [padding]="20"
  [textColor]="'var(--color-on-surface-high-emphasis)'"
  [editCloseIcon]="true"
>
  <div *ngIf="previewMarkModal.isModalOpened">
    <app-mark-payment-modal
      [selectedElement]="selectedElement"
      [type]="actionType"
      (closeModal)="previewMarkModal.closeModal()"
      (reloadComponent)="reloadComponent()"
    ></app-mark-payment-modal>
  </div>
</app-modal>
